import React from "react";
import CreatorComp from "../components/creator/creator";


const CreatorPage = () => {
  return (
    <CreatorComp />
  );
};

export default CreatorPage;
